import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";

export const requestDeleteVideo = async (videoId: string): Promise<void> => {
  return await instance.delete(buildUrl(ApiRoutesContent.FeedInserts, videoId));
};
